<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getToken} from '@/api/auth'

export default {
  name: 'App',

  mounted() {
    this.browserRedirect();
    if (getToken()) {
      this.$store.dispatch('GetUserInfo');
    }
    this.$store.dispatch('getIndexConfig');
  },
  methods:{
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase()
      var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
      var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
      var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
      var bIsAndroid = sUserAgent.match(/android/i) == 'android'
      var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
      var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
      if ((bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
        localStorage.setItem('device', JSON.stringify({ 'type': 'number', 'data': 1 })) // 作用于区分4个版本手机端是否有实名认证
        window.location.href = '/web/index/#/'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue